// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductListCategory_container__2owS-","tab":"ProductListCategory_tab__1Xfzz"};